import EditorBase from "../../../bryntum-lib/editors/base/EditorBase.jsx";
import EntityFinderTaskTab from "./EntityFinderTaskTab.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import EntityFinderResourceTab from "./EntityFinderResourceTab.jsx";
import EntityFinderClientTab from "./EntityFinderClientTab.jsx";
import EntityFinderBoardUserTab from "./EntityFinderBoardUserTab.jsx";
import EntityFinderContactTab from "./EntityFinderContactTab.jsx";
import EntityFinderBudgetTab from "./EntityFinderBudgetTab.jsx";
import EntityFinderChecklistTab from "./EntityFinderChecklistTab.jsx";

export default class SwivuEntityFinderPopup extends EditorBase {
  static get $name() {
    return "SwivuEntityFinder";
  }

  static get type() {
    return "swivuentityfinder";
  }

  static get configurable() {
    return {
      title: "",
      stateId: PERSISTENCE_STATE_KEYS.entityFinderEditor,
      closable: false,
      autoClose: false,
      defaultFocus: (w) => w.ref === "searchField",
      modal: false,
      draggable: true,
      contentElementCls: "gap-4",
      width: "30rem",
      minWidth: "30rem",
      maxWidth: "100vw",
      height: "40rem",
      minHeight: "40rem",
      maxHeight: "100vh",
      cls: "swivu-finder minimal-gradient-editor swivu-finder-minimal",
      tbar: {
        cls: "swiviu-finder-toolbar",
        items: {
          searchField: {
            type: "text",
            placeholder: "Entity Finder",
            onInput: "up.onSearchChange",
            onClear: "up.onSearchClear",
            clearable: true,
            flex: 1,
            cls: "swivu-finder-search",
            triggers: {
              searchIcon: {
                cls: 'b-fa b-fa-search pt-[1px]',
                align: "start",
              },
              escButton: {
                // text to this element is assigned from loadRecord/editRecord below
                cls: "text-[0.9em]",
                align: "end",
                handler: "up.close"
              }
            }
          }
        }
      },
      items: {
        tabs: {
          type: WIDGET_KEYS.swivuTabPanel,
          listeners: {
            tabChange: "up.onTabChangeHandler"
          },
          cls: "h-full",
          stateId: "swivu-entity-finder-editor-tab",
          items: {
            taskTab: { type: EntityFinderTaskTab.type },
            resourceTab: { type: EntityFinderResourceTab.type },
            clientTab: { type: EntityFinderClientTab.type },
            contactTab: { type: EntityFinderContactTab.type },
            userTab: { type: EntityFinderBoardUserTab.type },
            budgetTab: { type: EntityFinderBudgetTab.type },
            checklistTab: { type: EntityFinderChecklistTab.type }
          }
        }
      },
      bbar: {
        contentElementCls: "!pb-0 !pr-0",
        hidden: true,
        items: [{
          ref: "selectBtn",
          type: "button",
          text: "Link",
          color: "b-blue",
          cls: "b-raised",
          disabled: true,
          onClick: "up.onClickSelectBtn"
        }]
      }
    }
  }

  editRecord(record, context, otherParams) {
    super.editRecord(record, context, otherParams);
    const { onEntitiesSelected, isOnlyFinder, ...rest } = otherParams;
    this.widgetMap.searchField.triggers.escButton.element.innerText = "ESC";
    if (!isOnlyFinder) {
      this.onEntitiesSelected = onEntitiesSelected;
      if (this.widgetMap.bbar) {
        this.widgetMap.bbar.hidden = false;
      }
    }
    this.selectedRecords = {};
    this.widgetMap.tabs.eachWidget((widget) => {
      if (widget.isEntityFinderTabBase) {
        widget.editRecord(record, context, { ...rest, isOnlyFinder });
      }
    })
  }

  onGridSelectionChange({ selected, deselected, selection, source }) {
    const { selectBtn } = this.widgetMap;
    const tab = source.owner;
    const [tabTitle] = tab.title.split("(");
    tab.title = selection.length ? `${tabTitle.trim()} (${selection.length})` : tabTitle;
    if (!this.selectedRecords[tab.storeKey]) this.selectedRecords[tab.storeKey] = [];
    if (selected.length) {
      this.selectedRecords[tab.storeKey] = [
        ...this.selectedRecords[tab.storeKey],
        ...selected
      ]
    } else if (deselected.length) {
      this.selectedRecords[tab.storeKey] = this.selectedRecords[tab.storeKey].filter((record) => !(
        deselected.some((deselectedRecord) => deselectedRecord.id === record.id)
      ))
    }
    const selectedRecordsCount = Object.values(this.selectedRecords).reduce((previousCount, records) => previousCount + records.length, 0);
    selectBtn.text = selectedRecordsCount
      ? `Link ${selectedRecordsCount} ${selectedRecordsCount > 1 ? "Entities" : "Entity"}`
      : "Link";
    selectBtn.disabled = !selectedRecordsCount;
  }

  onClickSelectBtn() {
    this.close();
    this.onEntitiesSelected(this.selectedRecords);
  }

  onTabChangeHandler() {
    const searchField = this.widgetMap.searchField;
    searchField.focus();
    this.onSearchChange({ value: searchField.value });
  }

  onSearchClear() {
    this.onSearchChange({ value: "" });
  }

  onSearchChange({ value = "" }) {
    const activeTab = this.widgetMap.tabs.activeItem;
    const { searchField } = this.widgetMap;
    const { entityGrid } = activeTab.widgetMap;
    searchField.value = value;
    const { field } = entityGrid.columns.getById("entity-name");
    entityGrid.store.clearFilters();
    if (value.trim()) {
      entityGrid.store.filterBy((record) => record[field]?.trim().toLowerCase().includes(value.trim().toLowerCase()));
    }
  }
}
SwivuEntityFinderPopup.initClass();
